import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {GroupModel} from "@/modules/mconfigs/models/GroupModel";

export class BranchModel extends BaseObject {

    constructor() {
        super();

        this._name = null;
        this._order = null;
        this._createdAt = null;
        this._updatedAt = null;
        this._groups = [];
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get createdAt() {
        return this._createdAt;
    }

    set createdAt(value) {
        this._createdAt = value;
    }

    get updatedAt() {
        return this._updatedAt;
    }

    set updatedAt(value) {
        this._updatedAt = value;
    }

    get groups() {
        return this._groups;
    }

    set groups(value) {
        this._groups = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BranchModel());
        } else if (target instanceof BranchModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    valid() {
        if (!this._name || this._name.length === 0) {
            return "Name is required";
        }
        if (this._order === null || isNaN(this._order)) {
            return "Order is required";
        }
        if (this.groups) {
            for (const group of this.groups) {
                if (!group.valid()) {
                    return "Group '" + group.name + "' is invalid";
                }
            }
        }
        return null;
    }

    static schema() {
        return custom((v) => {
            return v ? serialize(BranchModel, v) : SKIP;
        }, (v) => {
            return deserialize(BranchModel, v);
        });
    }
}

createModelSchema(BranchModel, {
    _name: alias("name", Schema.primitive()),
    _order: alias("order", Schema.primitive()),
    _createdAt: alias("createdAt", Schema.primitive()),
    _updatedAt: alias("updatedAt", Schema.primitive()),
    _groups: alias("groups", list(GroupModel.schema())),
});